export const CONTACT = {
  email: "actionpackedadventures1@gmail.com",
  phone: "07713 241083",
  phoneHref: "tel:+447713241083",
  company: "OC455080",
  location: "The Downs Preparatory School",
};

export const IMAGES = {
  heroCheering:
    "https://customer-assets-jai6qajn.emergentagent.net/job_e2893b5b-ea14-497a-b9e2-27ef9e5d4e4b/artifacts/rvmwc3z5_image.png",
  coachesLogo:
    "https://customer-assets-agu9un31.emergentagent.net/job_thrills-await/artifacts/y5ah6hv8_IMG_6195.webp",
  coachChild:
    "https://customer-assets-agu9un31.emergentagent.net/job_thrills-await/artifacts/yoot7dqh_IMG_6590.webp",
  gallerySupplement:
    "https://customer-assets-agu9un31.emergentagent.net/job_thrills-await/artifacts/cfqill9z_IMG_6602.webp",
  galleryFence:
    "https://customer-assets-agu9un31.emergentagent.net/job_thrills-await/artifacts/a3qol8ot_IMG_6529.webp",
  galleryTable:
    "https://customer-assets-agu9un31.emergentagent.net/job_thrills-await/artifacts/l5c1ohjf_IMG_6367.webp",
};

export const NAV_LINKS = [
  { label: "About", id: "about" },
  { label: "Camps", id: "camps" },
  { label: "Book", id: "booking" },
  { label: "Gallery", id: "gallery" },
  { label: "Contact", id: "contact" },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "A Full, Happy Day",
    body: "Days are gently busy — a balanced mix of sport, games and quieter moments, so children stay engaged without ever feeling rushed.",
  },
  {
    num: "02",
    title: "Room to Grow",
    body: "Our coaches take the time to encourage every child, helping them build confidence, make new friends and enjoy trying something different.",
  },
  {
    num: "03",
    title: "Something for Everyone",
    body: "From team sports to creative games, there is plenty to enjoy, whatever a child is into — with swimming in the pool and day trips out at our Easter and summer camps.",
  },
];

export const SPORTS = [
  "Rugby",
  "Hockey",
  "Cricket",
  "Netball",
  "Tennis",
  "Swimming",
];

export const SCHOOL_YEARS = [
  "Year 1",
  "Year 2",
  "Year 3",
  "Year 4",
  "Year 5",
  "Year 6",
  "Year 7",
  "Year 8",
];

export const PRICING = [
  {
    id: "single-day",
    name: "Single Day",
    unit: "per child, per day",
    earlyPrice: "£40",
    standardPrice: "£50",
    tag: "Flexible",
    features: [
      "Come along for any single day",
      "Multi-sport & creative activities",
      "Fully qualified coaching team",
      "Perfect for a taster",
    ],
    variant: "white",
  },
  {
    id: "four-day",
    name: "4-Day Camp",
    unit: "per child, all four days",
    earlyPrice: "£144",
    standardPrice: "£180",
    tag: "Best Value",
    features: [
      "All four camp days (14–17 Dec)",
      "Best value — save on the daily rate",
      "Multi-sport, games & activities",
      "Fully qualified coaching team",
    ],
    variant: "sky",
  },
];

export const UPCOMING_CAMPS = [
  {
    id: "easter",
    name: "Easter Camp",
    season: "Spring 2027",
    blurb: "A fresh burst of sport, swimming in the pool, games and springtime adventures over the Easter holidays.",
  },
  {
    id: "summer",
    name: "Summer Camp",
    season: "Summer 2027",
    blurb: "Our biggest camp of the year — weeks of sport, swimming in the pool and day trips out, including to Noah's Ark Zoo Farm.",
  },
];

export const CAMP_DATES = [
  { day: "Mon", date: "14", month: "December" },
  { day: "Tue", date: "15", month: "December" },
  { day: "Wed", date: "16", month: "December" },
  { day: "Thu", date: "17", month: "December" },
];
